var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wallet-screen"}},[_c('hero-jumbotron',{attrs:{"backgroundImage":'/images/screens/wallet/desktop/header_image.jpg',"mobileBackgroundImage":'/images/screens/wallet/mobile/header_image.jpg',"overlayOpacity":0,"title":_vm.$t('walletScreen.welcomeComponent.title'),"description":_vm.$t('walletScreen.welcomeComponent.description'),"subDescription":_vm.$t('walletScreen.welcomeComponent.subDescription'),"showStores":true,"phoneImage":'/images/elements/home/web/home_phone.png',"phoneAlt":_vm.$t('walletScreen.heroJumbotron.phoneAlt')}}),_c('step-by-step-section',{attrs:{"title":_vm.$t('walletScreen.stepByStepSection.title'),"imageSide":'left',"imageSrc":'/images/screens/wallet/desktop/step1-mobile.png',"imageAlt":_vm.$t('walletScreen.stepByStepSection.imageAlt'),"items":[
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsOneTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsOneDescription'),
			},
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsTwoTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsTwoDescription'),
			},
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsThreeTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsThreeDescription'),
			},
		]}}),_c('step-by-step-section',{attrs:{"imageSide":'right',"imageSrc":'/images/screens/wallet/desktop/step2-mobile.png',"imageAlt":_vm.$t('walletScreen.stepByStepSection.imageAlt'),"items":[
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsFourTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsFourDescription'),
			},
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsFiveTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsFiveDescription'),
			},
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsSixTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsSixDescription'),
			},
		],"backgroundImage":'/images/elements/home/web/home_background.png',"backgroundImageMobile":'/images/screens/wallet/mobile/section-bg-mobile.png'}}),_c('step-by-step-section',{attrs:{"imageSide":'left',"imageSrc":'/images/screens/wallet/desktop/step3-mobile.png',"imageAlt":_vm.$t('walletScreen.stepByStepSection.imageAlt'),"items":[
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsSevenTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsSevenDescription'),
			},
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsEightTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsEightDescription'),
			},
			{
				title: _vm.$t('walletScreen.stepByStepSection.itemsNineTitle'),
				text: _vm.$t('walletScreen.stepByStepSection.itemsNineDescription'),
				gradientStart: '#D4F8ED99',
				gradientEnd: '#01DBA8',
			},
		]}}),_c('key-features',{attrs:{"title":_vm.$t('walletScreen.keyFeatures.title'),"backgroundImage":'/images/screens/wallet/desktop/key-features-bg.jpg',"mobileBackgroundImage":'/images/screens/wallet/mobile/key-features-bg-mobile.jpg',"features":[
			{
				icon: '/images/icons/asset-order-green.svg',
				title: _vm.$t('walletScreen.keyFeatures.item1'),
			},
			{
				icon: '/images/icons/license-green.svg',
				title: _vm.$t('walletScreen.keyFeatures.item2'),
			},
			{
				icon: '/images/icons/ethereum.svg',
				title: _vm.$t('walletScreen.keyFeatures.item3'),
			},
			{
				icon: '/images/icons/transfers-green.svg',
				title: _vm.$t('walletScreen.keyFeatures.item4'),
			},
			{
				icon: '/images/icons/shop-green.svg',
				title: _vm.$t('walletScreen.keyFeatures.item5'),
			},
			{
				icon: '/images/icons/security-green.svg',
				title: _vm.$t('walletScreen.keyFeatures.item6'),
			},
			{
				icon: '/images/icons/circle-check-green.svg',
				title: _vm.$t('walletScreen.keyFeatures.item7'),
			},
			{
				icon: '/images/icons/wallet-green.svg',
				title: _vm.$t('walletScreen.keyFeatures.item8'),
			},
		]}}),_c('wallet-mobile-suggester-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }